// packages
import moment from 'moment';

/**
 *
 * Criação do objecto de chamada.
 * Esta função irá preparar o objecto a ser enviado para API, onde só os campos
 * preenchidos na página é que serão enviados. Assim irá permitir usar esta função
 * na adição e na edição deste modelo.
 *
 * @param {Object}  data
 * @param {Object}  helpers
 *
*/
const create = ( data, { structureQuestions }) => {
    const answers = [];

    // construção da estrutura das respostas
    // para ser enviado para API.
    Object.keys( data )
        // Obtenção das respostas do script que tem como nome
        // números ( correspondem aos id's ) e que o groupo de campo
        // não tenha a classe `display--none`. Com a segunda condição
        // evita-se que os campos que foram preenchidos numa outra sequencia
        // do guião sejam enviados para API.
        .filter( key => /^\d+$/.test( key )
            && !document.querySelector( `.script__question[data-id="${key}"]` ).classList.contains( 'display--none' ) )
        .forEach( key => {
            const { possibleAnswers } = structureQuestions[key];

            // definição dos valores default.
            let answerId = possibleAnswers[0].value;
            let value = data[key];
            const additionalBehaviour = data[`additional-behaviour-answer[${data[key]}]`] || '';
            let finalValue = '';

            if ( !Array.isArray( value ) ) {
                if ( possibleAnswers.length > 1 ) {
                    // validação se existe mais que uma resposta possível
                    // caso exista, quer dizer que que o id da resposta é o valor
                    // selecionado através da input ( radiobutton ) e não é necessário enviar o
                    // o valor para a API.
                    answerId = data[key];
                    value = '';
                }

                finalValue = ( additionalBehaviour ) ? value + additionalBehaviour : value;

                answers.push({
                    scriptAnswerId: answerId,
                    ...( finalValue && { value: finalValue })
                });
            } else {
                // Se a responsta a uma pergunta for um array (checkboxes),
                // percorre as respostas e define os ids de cada resposta.
                value.forEach( answerValue => {
                    answerId = answerValue;
                    value = '';

                    finalValue = ( additionalBehaviour ) ? value + additionalBehaviour : value;

                    answers.push({
                        scriptAnswerId: answerId,
                        ...( finalValue && { value: finalValue })
                    });
                });
            }
        });

    const finalAnswers = {};
    answers.forEach( ( answer, index ) => {
        finalAnswers[`answers[${index}][script_answer_id]`] = answer.scriptAnswerId;
        if ( answer.value )
            finalAnswers[`answers[${index}][value]`] = answer.value;
    });

    const call = {
        id: data.id,
        _method: 'put',
        state_id: data.stateId,
        disable_recording: data.disableRecording ? 1 : 0,
        ...( data.rescheduleTo && {
            reschedule_to: moment( data.rescheduleTo ).utc().format( 'YYYY-MM-DD HH:mm' ),
            ...( data.newContactValue && {
                new_contact_type: 'phone',
                new_contact_value: data.newContactValue
            })
        }),
        ...( Object.keys( finalAnswers ).length && { ...finalAnswers }),
        ...( data.internalObservations && { observations: data.internalObservations })
    };

    return call;
};

const requiredFields = [ { field: 'stateId', isRequiredOnEdit: false } ];
export {
    create,
    requiredFields
};